import React from 'react';
import PropTypes from 'prop-types';
import {Box, IconButton, Stack} from '@mui/material';
import CancelIcon from '@mui/icons-material/Close';
import {DateTimePicker} from '@mui/x-date-pickers';
import moment from 'moment';
import {
    formatFormExpirationDate,
    toFormExpirationIso,
    toFormExpirationMoment,
} from '../../../utility/dateUtil';

const FormExpirationDatePicker = ({
    expirationDate,
    onExpirationDateChange,
    disabled = false,
    minDateTime,
    label = 'Expiration date (optional)',
    showClearButton = true,
    sx,
}) => {
    const value = toFormExpirationMoment(expirationDate);
    const helperText = expirationDate
        ? `Expires at ${formatFormExpirationDate(expirationDate)}`
        : 'Set an expiration date and time (your local time)';

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <Box sx={{flexGrow: 1, ...sx}}>
                <DateTimePicker
                    label={label}
                    disabled={disabled}
                    value={value}
                    onChange={(v) => onExpirationDateChange(toFormExpirationIso(v))}
                    format="MMM D, YYYY, HH:mm"
                    minDateTime={minDateTime ?? moment()}
                    ampm={false}
                    slotProps={{
                        textField: {
                            fullWidth: true,
                            helperText,
                            inputProps: {readOnly: true},
                        },
                        field: {readOnly: true},
                    }}
                />
            </Box>

            {showClearButton && expirationDate && !disabled && (
                <IconButton
                    aria-label="Clear expiration date"
                    onClick={() => onExpirationDateChange(null)}
                    size="small"
                    sx={{
                        transform: 'translateY(-10px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <CancelIcon fontSize="small"/>
                </IconButton>
            )}
        </Stack>
    );
};

FormExpirationDatePicker.propTypes = {
    expirationDate: PropTypes.string,
    onExpirationDateChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    minDateTime: PropTypes.object,
    label: PropTypes.string,
    showClearButton: PropTypes.bool,
    sx: PropTypes.object,
};

export default FormExpirationDatePicker;
